// Reads the admin role from the Firebase Auth custom claim.
//
// The claim is set only by functions/scripts/grant-superadmin.js (and later an
// admin callable) — never from the browser. This hook is for UI gating only;
// the real boundary is Firestore rules + the callables checking the same claim
// server-side.
import { getAuth, onAuthStateChanged } from "firebase/auth";
import { useEffect, useState } from "react";

const ADMIN_ROLES = ["superadmin", "admin", "support"];

// Returns the admin role, or null. forceRefresh pulls a fresh ID token so a
// claim granted since sign-in is picked up without signing out.
export async function getAdminRole(forceRefresh = false) {
  const user = getAuth().currentUser;
  if (!user) return null;
  try {
    const { claims } = await user.getIdTokenResult(forceRefresh);
    return ADMIN_ROLES.includes(claims.role) && claims.email_verified === true
      ? claims.role
      : null;
  } catch {
    return null;
  }
}

export function useAdminClaim() {
  const [role, setRole] = useState(null);
  const [checking, setChecking] = useState(true);

  useEffect(() => {
    return onAuthStateChanged(getAuth(), async (user) => {
      setRole(user ? await getAdminRole() : null);
      setChecking(false);
    });
  }, []);

  return { role, checking };
}
